/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Badge as SuiBadge } from '@one-thd/sui-atomic-components';

export const Badge = ({ text }) => {
  // note: background color could be replace later for the closest one in stencil(sui-bg-info-strong)
  // for now to get the same as in old badge.
  const isEventBadge = text === 'New This Season';
  let variant = 'regular';
  let badgeColor = 'info';
  if (isEventBadge) {
    badgeColor = 'brand';
  } else if (text === 'Delivery by Christmas') {
    badgeColor = 'success';
    variant = 'strong';
  }

  return (
    <SuiBadge variant={variant} color={badgeColor} size="small">{text}</SuiBadge>
  );
};

Badge.propTypes = {
  text: PropTypes.string.isRequired,
};
